var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.success)?_c('div',{class:_vm.withoutAnimation ? '' : 'uk-animation-fade'},[_c('InfoBox',{attrs:{"closeable":_vm.closeable,"mode":"success"}},[_vm._v(" "+_vm._s(_vm.message)+" "),_vm._t("default")],2)],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }